<template>
  <UserLayout>
    <router-view />
  </UserLayout>
</template>

<script>
import UserLayout from '@/components/UserLayout.vue'

export default {
  name: 'UserLayoutWrapper',
  components: {
    UserLayout
  }
}
</script> 